import { handleHttpResponse } from '../lib/handle-http-response'
import FranchisesAPI from '../api/franchises'

// Actions
export const LIST_FRANCHISES = 'LIST_FRANCHISES'
export const DELETE_FRANCHISE = 'DELETE_FRANCHISE'
export const GET_FRANCHISE = 'GET_FRANCHISE'
export const UPDATE_FRANCHISE = 'UPDATE_FRANCHISE'
export const CLEAR_FRANCHISE_REDIRECT = 'CLEAR_FRANCHISE_REDIRECT'

// Action Creators
export function clearRedirect() {
  return { type: CLEAR_FRANCHISE_REDIRECT }
}

export function listFranchises() {
  return (dispatch) => {
    return handleHttpResponse(dispatch, LIST_FRANCHISES, FranchisesAPI.list())
  }
}

export function deleteFranchise(id) {
  return (dispatch) => {
    return handleHttpResponse(dispatch, DELETE_FRANCHISE, FranchisesAPI.del(id), { id })
  }
}

export function getFranchise(id) {
  return (dispatch) => {
    return handleHttpResponse(dispatch, GET_FRANCHISE, FranchisesAPI.get(id))
  }
}

export const updateFranchise = (id, data) =>
  (dispatch) => 
    handleHttpResponse(dispatch, 
                       UPDATE_FRANCHISE, 
                       FranchisesAPI.update(id, data));

// Reducer
const initialState = {
  loading: false,
  error: null,
  list: [],
  current: null,
  redirectTo: null,
}

const listFranchisesHandler = (state, action) => {
  if (action.error) {
    return {
      ...state,
      loading: false,
      error: action.payload,
    }
  }

  let data = state.list
  if (action.payload && action.payload.list) {
    data = action.payload.list
  }

  return {
    ...state,
    loading: action.loading || false,
    error: null,
    list: data,
  }
}

const deleteFranchiseHandler = (state, action) => {
  if (action.error) {
    return { 
      ...state,
      loading: false,
      error: action.payload
    }
  }

  return {
    ...state,
    list: state.list.filter(f => f.id !== action.meta.id),
    current:
      state.current && state.current.id === action.meta.id ? null : state.current,
  }
}

const getFranchiseHandler = (state, action) => {
  if (action.error) {
    return {
      ...state,
      loading: false,
      error: action.payload,
      current: null,
    }
  }

  return {
    ...state,
    loading: action.loading || false,
    error: null,
    current: action.payload,
  }
}

const updateFranchiseHandler = (state, action) => {
  if (action.error) {
    return {
      ...state,
      loading: false,
      error: action.payload,
      redirectTo: null,
    }
  }

  return {
    ...state,
    loading: action.loading || false,
    error: null,
    redirectTo: !action.loading ? '/franchises' : null,
  }
}

const ACTION_HANDLERS = {
  [LIST_FRANCHISES]: listFranchisesHandler,
  [DELETE_FRANCHISE]: deleteFranchiseHandler,
  [GET_FRANCHISE]: getFranchiseHandler,
  [UPDATE_FRANCHISE]: updateFranchiseHandler,
  [CLEAR_FRANCHISE_REDIRECT]: (state) => ({ ...state, redirectTo: null }),
}

export default function franchisesReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
} 